export default "__VITE_PUBLIC_ASSET__abde0dde__"